import { NavLink } from "react-router-dom";
import classNames from "classnames";

const NavItem = ({ to, label, icon }) => {
    return <NavLink to={to} className={({ isActive }) => classNames("px-2.5 py-1.5 rounded-md flex gap-2 items-center hover:bg-backgroundGrey w-full", isActive ? "bg-backgroundGrey" : "")}>{icon}{label}</NavLink>
}

export default NavItem